export class UserSettings {
  language: ELanguage = ELanguage.EN;
  decimalSeperator: EDecimalSeperator = EDecimalSeperator.DOT;
  digitGrouping: EDigitGroupingSeperator = EDigitGroupingSeperator.COMMA;
  timezone: string = "local";
  datetimeOrder: EDatetimeOrder = EDatetimeOrder.TIMEDATE;
  timeformat: ETimeFormat = ETimeFormat.LOCAL;
  dateformat: EDateFormat = EDateFormat.LOCAL;
  autosave: boolean = true;
  reportingCurrency: string = "USD";

  deadlineReminderMail: boolean = false;
  deadlineExtensionMail: boolean = false;
  noSubmissionReceivedMail: boolean = false;
  tenderCommunicationMail: boolean = false;
  ccCarrierSubmissionMail: boolean = false;
  ccLanesTouchedButNotValidMail: boolean = false;
  tenderInvitationMail: boolean = false;
  ccNoAwardedCarriersMail: boolean = false;
  newCarrierInPoolMail: boolean = false;
  awardedMail: boolean = false;
  awardedLanesUpdatedMail: boolean = false;
  awardedLanesDeletedMail: boolean = false;
  contractedServicesChangedMail: boolean = false;
  ccMissingServices: boolean = false;
}

export enum EDatetimeOrder {
  TIMEDATE = 1,
  DATETIME
}

export enum EDecimalSeperator {
  COMMA = 1,
  DOT
}

export enum EDigitGroupingSeperator {
  COMMA = 1,
  DOT,
  SPACE,
  NONE
}

export enum ELanguage {
  EN = 1,
  DE,
  FR,
  ES,
  JP,
  KO
}

export enum ETimeFormat {
  LOCAL = 1,
  TWELVE,
  TWENTYFOUR
}

export enum EDateFormat {
  LOCAL = 1,
  EN,
  DE,
  CA
}
